'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _it_IT = require('../locale/it_IT');

var _it_IT2 = _interopRequireDefault(_it_IT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _it_IT2['default'];